import { useQuery } from "@apollo/react-hooks";
import { MY_TIMESHEET_GET_MESSAGES_LIST } from "my-timesheet/graphql";

export const useMyTimesheetMessagesList = ({ request }: { request: any }) => {
  const { data, loading, error, refetch } = useQuery(
    MY_TIMESHEET_GET_MESSAGES_LIST,
    {
      skip: !request,
      fetchPolicy: "cache-and-network",
      variables: { request },
    },
  );

  return {
    data: data?.listMyTimesheetMessages || [],
    loading,
    error,
    refetch,
  };
};

export default useMyTimesheetMessagesList;
